export function toAmPm(input?: string | Date | null): string {
  if (!input) return ''; // or return '--:--'

  if (input instanceof Date) {
    const hh = input.getHours();
    const mm = input.getMinutes();
    const period = hh < 12 ? 'AM' : 'PM';
    const h12 = hh % 12 === 0 ? 12 : hh % 12;
    return `${h12}:${String(mm).padStart(2, '0')} ${period}`;
  }

  const s = String(input).trim();
  // "YYYY-MM-DDTHH:mm(:ss…)"면 T 이후만 떼기, 아니면 원문 유지
  const timePart = s.includes('T') ? s.split('T')[1] : s;

  // 앞부분에서 첫 HH:mm만 추출 (초/오프셋은 무시)
  const m = timePart.match(/^(\d{2}):(\d{2})/);
  if (!m) return ''; // or '--:--'

  const hh = Number(m[1]);
  const mm = Number(m[2]);
  if (Number.isNaN(hh) || Number.isNaN(mm)) return ''; // 방어

  const period = hh < 12 ? 'AM' : 'PM';
  const h12 = hh % 12 === 0 ? 12 : hh % 12;
  return `${h12}:${String(mm).padStart(2, '0')} ${period}`;
}
